import React, { FC, ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SetupApartProps {
  className?: string;
  rightImg: string;
}

const SetupApart: FC<SetupApartProps> = ({ className = "", rightImg }) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div
      className={`nc-SetupApart relative  bg-[#050B20] lg:pr-4 mb-20 lg:mb-36`}
      data-nc-id="SetupApart"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left lg:justify-between">
        <div className="flex-grow ">
          <img className="" src={rightImg} alt="" />
        </div>
        <div className="px-8 space-y-5 lg:space-y-7">
          <h2 className="text-3xl !leading-tight font-semibold text-[#FFFFFF] md:text-4xl xl:text-5xl dark:text-neutral-100">
            Online, in-person, everywhere
          </h2>
          <span className="block !font-normal !text-md text-[#FFFFFFB2] dark:text-neutral-400">
            Choose from thousands of vehicles from multiple brands and buy
            online with Click & Drive, or visit us at one of our dealerships
            today.
          </span>

          <ButtonPrimary className="border border-white" onClick={() => navigate("/")}>
            Rent Now
          </ButtonPrimary>
        </div>
      </div>
    </div>
  );
};

export default SetupApart;
